export default "__VITE_ASSET__DrqoTcbl__"